/**
 * @fileoverview Requirement creation form sections and submit actions.
 * @module components/RequirementCreationView/RequirementCreationFields
 */
import { CircularProgress } from "@mui/material";
import styles from "./index.module.css";
import RequirementGeneralInfo from "./RequirementGeneralInfo.jsx";
import RequirementScianProfile from "./RequirementScianProfile.jsx";
import RequirementOptionalRequirements from "./RequirementOptionalRequirements.jsx";

const RequirementCreationActions = ({ onBack, form }) => {
  const {
    t,
    isSubmitting,
    areMandatoryFieldsComplete,
    hasErrors,
    handleSubmitRequirement,
  } = form;

  return (
    <div className={styles.buttonsContainer}>
      <button
        className={styles.cancelButton}
        onClick={onBack}
        disabled={isSubmitting}
      >
        {t("components.requirementCreationModal.cancel")}
      </button>
      <button
        className={styles.createButton}
        onClick={handleSubmitRequirement}
        disabled={!areMandatoryFieldsComplete || hasErrors || isSubmitting}
      >
        {isSubmitting ? (
          <>
            <CircularProgress size={20} color="inherit" />
            <span>{t("components.requirementCreationModal.sending")}</span>
          </>
        ) : (
          <>{t("components.requirementCreationModal.createRequirement")}</>
        )}
      </button>
    </div>
  );
};

const RequirementCreationFields = ({
  categories,
  sectors,
  originalCertifications,
  onBack,
  form,
}) => (
  <>
    <label className={styles.modalSubtitle}>
      {form.t("components.requirementCreationModal.generalInformation")}
    </label>
    <RequirementGeneralInfo categories={categories} form={form} />
    <label className={styles.modalSubtitle}>
      {form.t("components.requirementCreationModal.scianProfile")}
    </label>
    <RequirementScianProfile sectors={sectors} form={form} />
    <RequirementOptionalRequirements
      originalCertifications={originalCertifications}
      form={form}
    />
    <RequirementCreationActions onBack={onBack} form={form} />
  </>
);

export default RequirementCreationFields;
